import classNames from "classnames";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, NavLink, useHistory } from "react-router-dom";
import { createEventPlus, menuButton, RedLogo } from "../../assets";
import { setResetEventInfo } from "../../redux/appReducer";
import { capitalizeFirstLetter } from "../../utils/capitalizeFirstLetter";
import { HeaderPopup, NotificationList } from "../shared";

export const Roles = {
  member: "участник",
  organizer: "организатор",
  viewer: "зритель",
  guest: "посетитель",
  moderator: "модератор",
  administrator: "администратор",
};

const Header = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const profile = useSelector((state) => state.user.profile);

  const [visiblePopup, setVisiblePopup] = useState(false);

  const role = profile.role;

  const getActiveIcon = (url) => {
    if (history.location.pathname.includes(url)) {
      return true;
    }
  };

  const getActive = (url) => {
    if (history.location.pathname.includes(url)) {
      return true;
    }
  };

  const toggleVisiblePopup = () => {
    setVisiblePopup(!visiblePopup);
  };

  const onCreateEventClick = () => {
    dispatch(setResetEventInfo());
  };

  return (
    <>
      <header className={"header " + props.classes}>
        <div className="header__logo">
          <img src={RedLogo} alt="#" />
          <span>Justevents</span>
        </div>
        <nav className="header-nav">
          {role === "организатор" && (
            <Link
              onClick={onCreateEventClick}
              className="header__create-event"
              to="/organizer-panel/short-desc"
            >
              <img src={createEventPlus} alt="" /> <span>Создать мероприятие</span>
            </Link>
          )}
          <NavLink
            to={"/events/list"}
            className={classNames("header-nav__item", {
              active: getActive("/events/calendar") || getActive("/events/list"),
            })}
          >
            <div className="header-nav__icon">
              <i>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M9 10.5C9.14834 10.5 9.29334 10.456 9.41668 10.3736C9.54002 10.2912 9.63614 10.1741 9.69291 10.037C9.74968 9.89997 9.76453 9.74917 9.73559 9.60368C9.70665 9.4582 9.63522 9.32456 9.53033 9.21967C9.42544 9.11478 9.2918 9.04335 9.14632 9.01441C9.00083 8.98547 8.85003 9.00033 8.71299 9.05709C8.57594 9.11386 8.45881 9.20999 8.3764 9.33332C8.29399 9.45666 8.25 9.60166 8.25 9.75C8.25 9.94891 8.32902 10.1397 8.46967 10.2803C8.61032 10.421 8.80109 10.5 9 10.5ZM12.75 10.5C12.8983 10.5 13.0433 10.456 13.1667 10.3736C13.29 10.2912 13.3861 10.1741 13.4429 10.037C13.4997 9.89997 13.5145 9.74917 13.4856 9.60368C13.4567 9.4582 13.3852 9.32456 13.2803 9.21967C13.1754 9.11478 13.0418 9.04335 12.8963 9.01441C12.7508 8.98547 12.6 9.00033 12.463 9.05709C12.3259 9.11386 12.2088 9.20999 12.1264 9.33332C12.044 9.45666 12 9.60166 12 9.75C12 9.94891 12.079 10.1397 12.2197 10.2803C12.3603 10.421 12.5511 10.5 12.75 10.5ZM9 13.5C9.14834 13.5 9.29334 13.456 9.41668 13.3736C9.54002 13.2912 9.63614 13.1741 9.69291 13.037C9.74968 12.9 9.76453 12.7492 9.73559 12.6037C9.70665 12.4582 9.63522 12.3246 9.53033 12.2197C9.42544 12.1148 9.2918 12.0434 9.14632 12.0144C9.00083 11.9855 8.85003 12.0003 8.71299 12.0571C8.57594 12.1139 8.45881 12.21 8.3764 12.3333C8.29399 12.4567 8.25 12.6017 8.25 12.75C8.25 12.9489 8.32902 13.1397 8.46967 13.2803C8.61032 13.421 8.80109 13.5 9 13.5ZM12.75 13.5C12.8983 13.5 13.0433 13.456 13.1667 13.3736C13.29 13.2912 13.3861 13.1741 13.4429 13.037C13.4997 12.9 13.5145 12.7492 13.4856 12.6037C13.4567 12.4582 13.3852 12.3246 13.2803 12.2197C13.1754 12.1148 13.0418 12.0434 12.8963 12.0144C12.7508 11.9855 12.6 12.0003 12.463 12.0571C12.3259 12.1139 12.2088 12.21 12.1264 12.3333C12.044 12.4567 12 12.6017 12 12.75C12 12.9489 12.079 13.1397 12.2197 13.2803C12.3603 13.421 12.5511 13.5 12.75 13.5ZM5.25 10.5C5.39834 10.5 5.54334 10.456 5.66668 10.3736C5.79001 10.2912 5.88614 10.1741 5.94291 10.037C5.99968 9.89997 6.01453 9.74917 5.98559 9.60368C5.95665 9.4582 5.88522 9.32456 5.78033 9.21967C5.67544 9.11478 5.5418 9.04335 5.39632 9.01441C5.25083 8.98547 5.10003 9.00033 4.96299 9.05709C4.82594 9.11386 4.70881 9.20999 4.6264 9.33332C4.54399 9.45666 4.5 9.60166 4.5 9.75C4.5 9.94891 4.57902 10.1397 4.71967 10.2803C4.86032 10.421 5.05109 10.5 5.25 10.5ZM14.25 3H13.5V2.25C13.5 2.05109 13.421 1.86032 13.2803 1.71967C13.1397 1.57902 12.9489 1.5 12.75 1.5C12.5511 1.5 12.3603 1.57902 12.2197 1.71967C12.079 1.86032 12 2.05109 12 2.25V3H6V2.25C6 2.05109 5.92098 1.86032 5.78033 1.71967C5.63968 1.57902 5.44891 1.5 5.25 1.5C5.05109 1.5 4.86032 1.57902 4.71967 1.71967C4.57902 1.86032 4.5 2.05109 4.5 2.25V3H3.75C3.15326 3 2.58097 3.23705 2.15901 3.65901C1.73705 4.08097 1.5 4.65326 1.5 5.25V14.25C1.5 14.8467 1.73705 15.419 2.15901 15.841C2.58097 16.2629 3.15326 16.5 3.75 16.5H14.25C14.8467 16.5 15.419 16.2629 15.841 15.841C16.2629 15.419 16.5 14.8467 16.5 14.25V5.25C16.5 4.65326 16.2629 4.08097 15.841 3.65901C15.419 3.23705 14.8467 3 14.25 3ZM15 14.25C15 14.4489 14.921 14.6397 14.7803 14.7803C14.6397 14.921 14.4489 15 14.25 15H3.75C3.55109 15 3.36032 14.921 3.21967 14.7803C3.07902 14.6397 3 14.4489 3 14.25V7.5H15V14.25ZM15 6H3V5.25C3 5.05109 3.07902 4.86032 3.21967 4.71967C3.36032 4.57902 3.55109 4.5 3.75 4.5H14.25C14.4489 4.5 14.6397 4.57902 14.7803 4.71967C14.921 4.86032 15 5.05109 15 5.25V6ZM5.25 13.5C5.39834 13.5 5.54334 13.456 5.66668 13.3736C5.79001 13.2912 5.88614 13.1741 5.94291 13.037C5.99968 12.9 6.01453 12.7492 5.98559 12.6037C5.95665 12.4582 5.88522 12.3246 5.78033 12.2197C5.67544 12.1148 5.5418 12.0434 5.39632 12.0144C5.25083 11.9855 5.10003 12.0003 4.96299 12.0571C4.82594 12.1139 4.70881 12.21 4.6264 12.3333C4.54399 12.4567 4.5 12.6017 4.5 12.75C4.5 12.9489 4.57902 13.1397 4.71967 13.2803C4.86032 13.421 5.05109 13.5 5.25 13.5Z"
                    fill={
                      getActiveIcon("/events/calendar") || getActiveIcon("/events/list")
                        ? "#C90113"
                        : "#727E8E"
                    }
                  />
                </svg>
              </i>
            </div>
            <div className="header-nav__name">Event календарь</div>
          </NavLink>
          <NavLink
            to={"/favorite/actual"}
            className={classNames("header-nav__item", {
              active: getActive("/favorite"),
            })}
          >
            <div className="header-nav__icon">
              <i>
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 18 18"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M3 3C3 2.17157 3.67157 1.5 4.5 1.5H13.5C14.3284 1.5 15 2.17157 15 3V15.75C15 16.0309 14.843 16.2883 14.5932 16.4169C14.3434 16.5454 14.0427 16.5236 13.8141 16.3603L9 12.9217L4.18593 16.3603C3.95732 16.5236 3.65662 16.5454 3.40681 16.4169C3.15701 16.2883 3 16.0309 3 15.75V3ZM13.5 3L4.5 3V14.2926L8.56407 11.3897C8.82484 11.2034 9.17515 11.2034 9.43593 11.3897L13.5 14.2926V3Z"
                    fill={getActiveIcon("/favorite") ? "#C90113" : "#727E8E"}
                  />
                </svg>
              </i>
            </div>
            <div className="header-nav__name">
              {role === "посетитель" && "Мои мероприятия"}
              {role === "участник" && "Мои стенды"}
              {role === "организатор" && "Мои мероприятия"}
            </div>
          </NavLink>
        </nav>
        <div className="header-profile">
          <div className="header-profile__icon">
            <NotificationList />
          </div>
          <div className="header-profile__user" onClick={toggleVisiblePopup}>
            <div className="header-profile__name">{profile.fullName}</div>
            <div className="header-profile__pos">
              {capitalizeFirstLetter(profile.role)}
            </div>
          </div>
          <div className="header-profile__avatar" onClick={toggleVisiblePopup}>
            <img src={profile.avatar} alt="#" />
          </div>
          <div className="header-profile__menu">
            <img src={menuButton} alt="Menu button" onClick={toggleVisiblePopup} />
            {visiblePopup && (
              <div className="header-profile__popup">
                <HeaderPopup closePopup={() => setVisiblePopup(false)} />
              </div>
            )}
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;
